var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: "Nova fatura", loading: _vm.loadingInvoiceForm } },
    [
      _c("sc-form", {
        attrs: { form: _vm.invoiceForm, rules: _vm.rules },
        on: { submit: _vm.saveInvoice },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Transportadora",
                            prop: "logisticProviderId",
                            expanded: ""
                          }
                        },
                        [
                          _c("sc-logistic-provider-dropdown", {
                            on: {
                              input: function($event) {
                                _vm.clearFieldsForCorreios(fields)
                              }
                            },
                            model: {
                              value: fields.logisticProviderId,
                              callback: function($$v) {
                                _vm.$set(fields, "logisticProviderId", $$v)
                              },
                              expression: "fields.logisticProviderId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Método de entrega",
                            prop: "deliveryMethodId",
                            expanded: ""
                          }
                        },
                        [
                          _c("sc-delivery-method-dropdown", {
                            attrs: {
                              "logistic-provider-id": fields.logisticProviderId
                            },
                            model: {
                              value: fields.deliveryMethodId,
                              callback: function($$v) {
                                _vm.$set(fields, "deliveryMethodId", $$v)
                              },
                              expression: "fields.deliveryMethodId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Data de vencimento",
                            prop: "dueDate",
                            expanded: ""
                          }
                        },
                        [
                          _c(
                            "sc-datepicker",
                            {
                              attrs: { placeholder: "Selecione uma data" },
                              model: {
                                value: fields.dueDate,
                                callback: function($$v) {
                                  _vm.$set(fields, "dueDate", $$v)
                                },
                                expression: "fields.dueDate"
                              }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "button is-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function() {
                                      return (fields.dueDate = null)
                                    }
                                  }
                                },
                                [
                                  _c("sc-icon", { attrs: { icon: "times" } }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Limpar")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Fatura (até 15mb)",
                            prop: "invoiceFiles",
                            expanded: ""
                          }
                        },
                        [
                          _c("sc-files-upload", {
                            ref: "invoiceFilesUpload",
                            attrs: {
                              "label-idle":
                                "Arraste e solte ou clique seu arquivo Excel (.XLSX / .CSV)",
                              "max-file-size": "15MB",
                              "accepted-file-types": _vm.acceptFilesInvoices
                            },
                            on: {
                              addfilestart: function(file) {
                                return (fields.invoiceFiles = file)
                              },
                              removefile: function() {
                                return (fields.invoiceFiles = null)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: fields.logisticProviderId !== 1,
                          expression: "fields.logisticProviderId !== 1"
                        }
                      ],
                      staticClass: "column"
                    },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "CT-e (até 200mb)",
                            prop: "ctesFiles",
                            expanded: ""
                          }
                        },
                        [
                          _c("sc-files-upload", {
                            ref: "ctesFilesUpload",
                            attrs: {
                              "label-idle":
                                "Arraste e solte ou clique seu arquivo compactado (.ZIP / .RAR)",
                              "max-file-size": "200MB",
                              "accepted-file-types": _vm.acceptFilesCtes
                            },
                            on: {
                              addfilestart: function(file) {
                                return (fields.ctesFiles = file)
                              },
                              removefile: function() {
                                return (fields.ctesFiles = null)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c(
                  "router-link",
                  {
                    staticClass: "button",
                    attrs: { to: { name: "invoice-audit-list" } }
                  },
                  [_vm._v("\n        Voltar\n      ")]
                ),
                _vm._v(" "),
                _c("sc-button", {
                  attrs: { text: "Salvar", type: "submit", theme: "primary" }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-503d98bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503d98bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-new/PageInvoiceAuditNew.vue
// module id = null
// module chunks = 